import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import ClientList from "src/components/Reviewer/Client/Client-list";
// import ClientList from "src/components/Subject-Matter-Expert/Client/Client-list";

// ----------------------------------------------------------------------

export default function SubjectmatterexpertClients() {
  return (
    <>
      <Helmet>
        <title> Clients </title>
      </Helmet>

      <Container maxWidth="xl">
        <ClientList Role="Subjectmatterexpert" />
      </Container>
    </>
  );
}
